import { N15_02 } from "./N15_02";

export const N15_01 = {
  selectedValueColumn: "CycleIndex",
  selectedTitle: "Region",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Region",
        binding: {
          data: {
            columns: [
              {
                name: "Region",
                columnName: "RegionName",
                width: "400px",
                align: "left",
                sortable: true
              },
              {
                name: "Total Count",
                columnName: "TotalCount",
                width: "180px",
                align: "center",
                sortable: true
              },
            ],
            title: "RegionName",
            endpoint: "SFE_N15.1",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "CycleIndex", value: "" },
            ],
          },
          context: {
            point: {
              onClick: N15_02,
            },
          },
        },
      },
    },
  ],
};